import React, { useState, useRef } from "react";
import Main from "../Main";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";

import { balanceEnquiry, cashWithdrawal } from "../../api/aepsApi";
import { getLocation } from "../../components/Navigator/Navigator";
import { useInactivityTimeout } from "../../hooks/useInactivityTimeout";
import BalanceResultPopup from "./BalanceResultPopup";

import { useBankList } from "../../context/authBankContext";
import { useEffect } from "react";
import './aadhaarStyle.css'

import { useFingerprintCapture } from "../../hooks/useFingerprintCapture";
import FingerprintModal from "../../hooks/FingerprintModal";
import { useNotify } from "../../context/NotifyContext";
import { setLocation } from "../../features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import AepsPipeSelect from "../../components/AepsPipeSelect";




const BalanceEnquiry = () => {
  const [amountLoading, setAmountLoading] = useState(false);
  const [txnLoading, setTxnLoading] = useState(false);
const { notify } = useNotify();
    const { location: savedLocation } = useSelector((state) => state.auth); // get location from Redux
  const pipe = useSelector((s) => s.aeps.pipe); // get location from Redux
const dispatch = useDispatch();
const [fetchingLocation, setFetchingLocation] = useState(false);

  const {
  pidData,
  fpStatus,
  fingerLoading,
  step,
  error,
  captureFingerprint,
  resetFingerprint,
} = useFingerprintCapture();

const { banklist, aepsloading } = useBankList();
  const [form, setForm] = useState({
    aadhaar: "",
    mobile: "",
    bankiin: "",
  });
  // const [pidData, setPidData] = useState("");

// values: "", "success", "error"

  const [loading, setLoading] = useState(false);
  const [balanceData, setBalanceData] = useState(null);
  const fetchedRef = useRef(false);

const validateForm = () => {
  // Aadhaar
  if (!form.aadhaar || !/^\d{12}$/.test(form.aadhaar)) {
    notify("Enter valid 12 digit Aadhaar number", "error");
    return false;
  }

  // Mobile
  if (!form.mobile || !/^[6-9]\d{9}$/.test(form.mobile)) {
    notify("Enter valid 10 digit mobile number", "error");
    return false;
  }

  // Bank
  if (!form.bankiin) {
    notify("Please select bank", "error");
    return false;
  }

    if (!pipe) {
    notify("Please select BankPipe", "error");
    return false;
  }

  return true;
};



  // 🔐 Clear everything
  const clearSession = () => {
    setForm({
      aadhaar: "",
      mobile: "",
      bankiin: "",
    });
    resetFingerprint()
    setBalanceData(null);
    fetchedRef.current = false;
  };

  // ⏳ Auto session expire (10 min)
  useInactivityTimeout(() => {
    if (balanceData) {
      clearSession();
      notify("Session expired due to inactivity",'warning');
    }
  }, 10 * 60 * 1000);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // numeric only for aadhaar & mobile
    if ((name === "aadhaar" || name === "mobile") && !/^\d*$/.test(value)) {
      return;
    }

    setForm({ ...form, [name]: value });
  };






const submit = async (pid) => {
  if (!validateForm()) return;

  if (!pid) {
    notify("Fingerprint data missing", "error");
    return;
  }

  try {
setFetchingLocation(true);
  let location;

  try {
    // ✅ Check Redux first
    if (savedLocation) {
      location = savedLocation;
    } else {
      // ✅ If not in Redux, fetch geolocation
      location = await getLocation();
      dispatch(setLocation(location)); // store in Redux for future use
    }
  } catch {
    setFetchingLocation(false);
    return notify("Location permission required", "error");
  }

  setFetchingLocation(false);


    const payload = {
      aadhaar: form.aadhaar,
      mobile: form.mobile,
      bankiin: form.bankiin,
      pidData: pid,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const res = await balanceEnquiry(payload);

   if (res.success) {
  setBalanceData(res.data);
  notify("Balance fetched successfully", "success");
} else {
  notify(res.message, "error");
  resetFingerprint();
}

  } catch (err) {
    notify("Network / Server error", "error");
    resetFingerprint();
  }
};



 const handleAmountFromPopup = async (amount) => {
  if (!amount || isNaN(amount) || Number(amount) <= 0) {
    notify("Enter valid withdrawal amount", "error");
    return;
  }

  if (!validateForm()) return;

  if (!pidData) {
    notify("Fingerprint required", "error");
    return;
  }

  setAmountLoading(true);

  try {
  setFetchingLocation(true);
  let location;

  try {
    // ✅ Check Redux first
    if (savedLocation) {
      location = savedLocation;
    } else {
      // ✅ If not in Redux, fetch geolocation
      location = await getLocation();
      dispatch(setLocation(location)); // store in Redux for future use
    }
  } catch {
    setFetchingLocation(false);
    return notify("Location permission required", "error");
  }

  setFetchingLocation(false);

    const payload = {
      aadhaar: form.aadhaar,
      mobile: form.mobile,
      amount: Number(amount),
      bankiin: balanceData?.bankiin,
      pidData,
      pipe,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const result = await cashWithdrawal(payload);
    if (result?.data?.status === true) {
      notify("Cash withdrawal successful", "success");
      clearSession();
    } else {
      notify(result?.message || "Cash withdrawal failed", "error");
    }
  } catch (err) {
    notify("Server error", "error");
  } finally {
    setAmountLoading(false);
  }
};



const handleBankChange = (e) => {
  const value = e.target.value;
  setForm(prev => ({
    ...prev,
    bankiin: value
  }));
};




const handleAddBeneficiaryClick = async () => {
  if (!validateForm()) return;

  try {
    setTxnLoading(true);

    const pid = await captureFingerprint(pipe); // modal opens
    if (!pid) {
      notify("Fingerprint capture cancelled", "error");
      return;
    }

    await submit(pid);
  } finally {
    setTxnLoading(false);
  }
};






  return (
    <Main showRightPanel={false}>
      <AppBreadcrumbs
        items={[
          { label: "Dashboard", to: "/" },
          { label: "Aadhaar" },
          { label: "Balance Enquiry" },
        ]}
      />



   <FingerprintModal open={fingerLoading} step={step} />



      <div className="flex flex-col lg:flex-row gap-6">
        <div className="ds-card w-full max-w-sm">
          <h2 className="text-sm font-semibold mb-4 text-[var(--text-dark)]">
            Aadhaar Balance Enquiry
          </h2>

          <form onSubmit={submit} className="space-y-4">
{fpStatus === "success" && !balanceData && (
  <div className="make-text-primary text-sm">
    ✔ Fingerprint verified, fetching balance...
  </div>
)}

{fpStatus === "error" && (
  <div className="text-[var(--error-color)] text-sm">{error}</div>
)}

<AepsPipeSelect />

            <select
  className="ds-input text-sm"
  value={form.bankiin}
  onChange={handleBankChange}
  disabled={aepsloading}
>
  <option value="">
    {aepsloading ? "Loading Banks..." : "Select Bank Name"}
  </option>

{banklist.map((bank, index) => (
  <option
    key={`${bank.iinno}-${index}`}
    value={bank.iinno}
  >
    {bank.bankName}
  </option>
))}

</select>
            <div>
              <label className="ds-label">Aadhaar Number</label>
              <input
                name="aadhaar"
                maxLength={12}
                value={form.aadhaar}
                onChange={handleChange}
                className="ds-input"
                placeholder="Aadhaar Number"
              />
            </div>

            <div>
              <label className="ds-label">Mobile Number</label>
              <input
                name="mobile"
                maxLength={10}
                value={form.mobile}
                onChange={handleChange}
                className="ds-input"
                placeholder="Mobile Number"
              />
            </div>

            <button
  type="button"
  className="ds-btn ds-btn-primary w-full"
  onClick={handleAddBeneficiaryClick}
  disabled={fingerLoading || txnLoading || balanceData}
>
  {fingerLoading
    ? "Capturing Fingerprint..."
    : txnLoading
    ? "Processing Wait..."
    : "Check Balance"}
</button>

              </form>
        </div>

        {balanceData && (
          <BalanceResultPopup
            details={balanceData}
            close={clearSession}
             onSubmitAmount={handleAmountFromPopup}
             loading={amountLoading}
          />
        )}
      </div>
    </Main>
  );
};

export default BalanceEnquiry;
